var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1569 10.4929L7.91421 6.25023L12.1569 2.00759C12.3444 1.82005 12.4497 1.5657 12.4497 1.30048C12.4497 1.03527 12.3444 0.780914 12.1569 0.593378C11.9693 0.405841 11.715 0.300485 11.4497 0.300485C11.1845 0.300485 10.9302 0.405841 10.7426 0.593378L6.5 4.83602L2.25736 0.593378C2.06982 0.405841 1.81547 0.300485 1.55025 0.300485C1.28504 0.300485 1.03068 0.405841 0.843146 0.593378C0.655609 0.780914 0.550253 1.03527 0.550253 1.30048C0.550253 1.5657 0.655609 1.82005 0.843146 2.00759L5.08579 6.25023L0.843146 10.4929C0.655609 10.6804 0.550252 10.9348 0.550252 11.2C0.550252 11.4652 0.65561 11.7195 0.843146 11.9071C1.03068 12.0946 1.28504 12.2 1.55025 12.2C1.81547 12.2 2.06982 12.0946 2.25736 11.9071L6.5 7.66445L10.7426 11.9071C10.9302 12.0946 11.1845 12.2 11.4497 12.2C11.715 12.2 11.9693 12.0946 12.1569 11.9071C12.3444 11.7195 12.4497 11.4652 12.4497 11.2C12.4497 10.9348 12.3444 10.6804 12.1569 10.4929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ffb8157a9ac3dc9dc8037ece40fa6ea8.svg";
export { ForwardRef as ReactComponent };